import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ConfigService } from '../../core/config.service';
import { BasicFollowUpOrderContent, Task } from '../../shared/task';
import { TaskService } from '../../shared/task.service';

interface TaskWithBasicFollowUpOrderContent extends Task {
  content: BasicFollowUpOrderContent;
}

@Component({
  selector: 'om-basic-follow-up-order-details',
  templateUrl: './basic-follow-up-order-details.component.html',
  styleUrls: ['./basic-follow-up-order-details.component.scss', '../_shared-task-details.scss'],
})
export class BasicFollowUpOrderDetailsComponent implements OnInit {
  @Input() task: TaskWithBasicFollowUpOrderContent;
  @Output() completed = new EventEmitter();
  submitting = false;

  constructor(public config: ConfigService, private taskService: TaskService) {}

  ngOnInit() {}

  assignFeedback(option) {
    this.task.content.feedback = option;
  }

  submitFeedback() {
    this.submitting = true;

    this.completed.emit({
      completionData: { feedback: this.task.content.feedback },
    });
  }
}
